/**
 * @generated SignedSource<<d82f7c7ec8da7d7b6b375400d48e5131>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoEditMoveToCategoryQuery$variables = {
  id: string;
};
export type TodoEditMoveToCategoryQuery$data = {
  readonly currentStore: {
    readonly id: string;
    readonly todoCategories: ReadonlyArray<{
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"TodoEditMoveToCategorySelector_todoCategories">;
    }>;
  };
  readonly todo: {
    readonly categoryId: string;
    readonly id: string;
    readonly teams: ReadonlyArray<{
      readonly id: string;
    }>;
  } | null;
};
export type TodoEditMoveToCategoryQuery = {
  response: TodoEditMoveToCategoryQuery$data;
  variables: TodoEditMoveToCategoryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "kind": "Literal",
    "name": "includeDefault",
    "value": true
  }
],
v3 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "id"
    }
  ],
  "concreteType": "Todo",
  "kind": "LinkedField",
  "name": "todo",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "categoryId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "teams",
      "plural": true,
      "selections": [
        (v1/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TodoEditMoveToCategoryQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": null,
          "concreteType": "Store",
          "kind": "LinkedField",
          "name": "currentStore",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            {
              "alias": null,
              "args": (v2/*: any*/),
              "concreteType": "TodoCategory",
              "kind": "LinkedField",
              "name": "todoCategories",
              "plural": true,
              "selections": [
                (v1/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "TodoEditMoveToCategorySelector_todoCategories"
                }
              ],
              "storageKey": "todoCategories(includeDefault:true)"
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      },
      (v3/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TodoEditMoveToCategoryQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "currentStore",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "TodoCategory",
            "kind": "LinkedField",
            "name": "todoCategories",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "icon",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isDefault",
                "storageKey": null
              }
            ],
            "storageKey": "todoCategories(includeDefault:true)"
          }
        ],
        "storageKey": null
      },
      (v3/*: any*/)
    ]
  },
  "params": {
    "cacheID": "f3c4743626d34bbdfaa2e0fba041e494",
    "id": null,
    "metadata": {},
    "name": "TodoEditMoveToCategoryQuery",
    "operationKind": "query",
    "text": "query TodoEditMoveToCategoryQuery(\n  $id: ID!\n) {\n  currentStore {\n    id\n    todoCategories(includeDefault: true) {\n      id\n      ...TodoEditMoveToCategorySelector_todoCategories\n    }\n  }\n  todo(id: $id) {\n    id\n    categoryId\n    teams {\n      id\n    }\n  }\n}\n\nfragment TodoEditMoveToCategorySelector_todoCategories on TodoCategory {\n  id\n  title\n  icon\n  isDefault\n}\n"
  }
};
})();

(node as any).hash = "0043a9822df2f31a93bfaa73dfd3af03";

export default node;
